import * as $ from 'jquery';
import 'jquery-colorbox';

const offerInquiry = () => {
	$('a[href*="get-quote.html"]').colorbox({
		transition: 'elastic',
		opacity: .60,
		width: '93%',
		maxWidth: '760',
		maxHeight: '93%',
		fixed: true,
		close: '<span>Close</span>',
		html: () => {
			const indirection: any = {};
			$.ajax($.colorbox.element().attr('href'), {async: false, success: data => indirection.result = data});
			return $(indirection.result).find('#formWrapper');
		},
		onComplete: () => {
			$.colorbox.resize();
			document.querySelector('html').classList.toggle('lockScroll');
		},
		onCleanup: () => {
			document.querySelector('html').classList.toggle('lockScroll');
		}
	});
};

export default offerInquiry;